import { FormLayout, Stack } from '@customerio/pluma-components/react';
import {
  BucketNameAndPathFields,
  bucketPreviewPath,
  ConfigTextArea,
  CredentialsHelp,
  TooltipLink,
  UploadPathPreview,
} from './fields';
import type { ProviderFormProps } from './types';

const GCS_SERVICE_ACCOUNT_DOCS_URL = 'https://cloud.google.com/iam/docs/creating-managing-service-account-keys';

/**
 * Built from the full `bucket/path`, as the S3 and Yandex links are — the console
 * addresses a prefix, not just a bucket. The app being replaced passed the bucket
 * name alone here, so its link pointed at `/browser/` with nothing after it while
 * the line beside it read `gcs://my-bucket/my-path`.
 */
function consoleUrl(path: string): string {
  return `https://console.cloud.google.com/storage/browser/${path}`;
}

/** Bucket and service account key for a Google Cloud Storage sync. */
export function GcsForm(props: ProviderFormProps) {
  const path = bucketPreviewPath(props.config);

  return (
    <FormLayout>
      <BucketNameAndPathFields form={props} />

      <UploadPathPreview
        scheme="gcs"
        path={path}
        tooltip={
          <>
            View files in your <TooltipLink href={consoleUrl(path)}>Google Cloud Storage console</TooltipLink>
          </>
        }
      />

      <Stack>
        <CredentialsHelp>
          <>
            Your service account keys can be found in your Google Cloud Console. Learn more about{' '}
            <TooltipLink href={GCS_SERVICE_ACCOUNT_DOCS_URL}>GCS service account keys</TooltipLink>.
          </>
        </CredentialsHelp>

        <ConfigTextArea form={props} field="credentials" label="Service account key (JSON format)" rows={6} />
      </Stack>
    </FormLayout>
  );
}
